export default (state = {}, action) => {
  switch (action.type) {
    case 'SET_A_FLIGHT_STAT':
      return action.data
    case 'CLEAR_SELECTED_FLIGHT':
      return {}
    default:
      return state
  }
}